import React, { useState, createContext } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import axios from "axios";

export const AppContext = createContext({} as any);


const AppProvider: React.FC = ({ children }) => {
  const [subAccountId, setSubAccountId] = useState('')
  const [logo, setLogo] = useState('https://bria-assets.s3.sa-east-1.amazonaws.com/logos+checkout/logo_bria.png')
  const [lead, setLead] = useState<any>({});
  const [paymentData, setPaymentData] = useState<any>({});
  const [plan, setPlan] = useState<any>(
    {
      plan_selected: 'deafult',
      price: '00,0',
      plans_description:[
      {
        productDetailName: 'Auxilio Funeral',
        productDetailDescrition: '',
        productDetailIconName: 'string',
        productDetailIconUrl: 'https://bria-assets.s3.sa-east-1.amazonaws.com/icons_checkout/cicle.svg'
      },
      {
        productDetailName: 'Telemedicina',
        productDetailDescrition: '',
        productDetailIconName: '',
        productDetailIconUrl: 'https://bria-assets.s3.sa-east-1.amazonaws.com/icons_checkout/message_plus.svg'
      }
    ]
    }
  );
  const [accountTheme, setAccountTheme] = useState<any>({
    palette: {
      primary: {
        main: "#2f054d",
      },
      secondary: {
        main: "#f88675",
      },
    },
  });

  // const leadId = useHistory().location.pathname.split("/")[1];

  const getLead = async (leadId: string) => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/leads/${leadId}`,
    });
    if (response.data) {
      setLead(response.data);
    }
    return response.data; // console.log("response", response.data.subAccounts[0].theme);
  };

  const updateLead = async (data: any) => {
    const response = await axios({
      method: "put",
      url: `${process.env.REACT_APP_API}/leads/${lead.leadId}`,
      headers: { "Content-Type": "application/json" },
      data: data,
    });
    if (response.data.leadId) {
      setLead({
        ...lead,
        ...data,
      });
      return true;
    }
    return false;
  };

  const createLead = async (data: any) => {
    console.log("createLead", data);
    const dataSubaccountId = {
      ...data,
      subAccountId: subAccountId,
    };
    console.log("createLeadSub", dataSubaccountId);
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API}/leads`,
      headers: { "Content-Type": "application/json" },
      data: dataSubaccountId,
    });
    if (response.data.leadId) {
      const newlead = {
        ...dataSubaccountId,
        leadId: response.data.leadId,
      };
      setLead(newlead);
      console.log(response.data);
      return true;
    }
    return false;
  };

  const checkout = async (data: any) => {
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API}/checkout`,
        headers: { "Content-Type": "application/json" },
        data: data,
      });
      return response.data
    } catch (e) {
      return false
    }
  }

  const subscribed = async (id: any) => {
    try {
      const response = await axios({
        method: "put",
        url: `${process.env.REACT_APP_API}/leads/subscribed/${id}`,
        headers: { "Content-Type": "application/json" },
      });
      console.log(response.data)
      return response.data
    } catch (e) {
      return false
    }
  }
  
  const getThemeAndPlans = async (id: string) => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/products/${id}`,
    });
    if (response) {
      console.log("responseGetTheme", response);
      
      const responsePlan = {
        plan_selected: response.data.productName,
        price: response.data.productValue,
        plans_description: response.data.productDetails
      }
      const responseTheme = {
        palette: {
          primary: {
            main: response.data.productColors[0].productColorMain,
          },
          secondary: {
            main: response.data.productColors[1].productColorMain,
          },
        },
      }
      console.log(responseTheme)
      setSubAccountId(response.data.subAccountId)
      setPlan(responsePlan)
      setAccountTheme(responseTheme)
      setLogo(response.data.subAccountLogo)
      updateEvent({type: 'ACESSO', subAccountId: response.data.subAccountId})
    }
  };

  const updatePaymentData = (data: any) => {
    setPaymentData({
      ...paymentData,
      data,
    })
    console.log("PaymentData", paymentData)
  }
  const updateEvent = async (data: any) => {
    try {
      const dataSubaccountId = data.subAccountId === '' ? {
        ...data,
        subAccountId: subAccountId,
      } : data;
      console.log(dataSubaccountId);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API}/events`,
        headers: { "Content-Type": "application/json" },
        data: dataSubaccountId
      });
      return response.data.eventId;
    } catch (e) {
      console.log(e);
    }
  }
  const theme = createTheme(accountTheme);
  return (
    <ThemeProvider theme={theme}>
      <AppContext.Provider
        value={{
          lead,
          theme,
          getThemeAndPlans,
          getLead,
          updateLead,
          createLead,
          checkout,
          subscribed,
          plan,
          logo,
          paymentData,
          updatePaymentData,
          updateEvent
        }}
      >
        {children}
      </AppContext.Provider>
    </ThemeProvider>
  );
};

export default AppProvider;
